/* oxlint-disable @typescript-eslint/no-explicit-any */
export function mapToObj<K extends keyof any, V>(keys: readonly K[], fn: (key: K) => V): Record<K, V> {
  return keys.reduce((acc, key) => ({ ...acc, [key]: fn(key) }), {} as Record<K, V>);
}
